import Header from "../componentes/Header";
import HomeSection from "../componentes/HomeSection";

function Home() {
    return (
        <>
            <Header/>
            <HomeSection />
        </>
    )
}

export default Home;